module.exports = {
  localeName: 'en-ZA',
  momentFormat: 'YYYY/MM/DD'
};
